import { Input } from "../../../../components/global";

const Name = () => <Input name="res_nome" type="text" label="Nome da coluna" />;

const TableOrigin = () => (
    <Input name="res_proveniente" type="text" label="Tabela de origem" />
);

export const FilterInputs = [Name];

export const CreateInputs = [Name, TableOrigin];
